/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-04-07 09:30:51
 * @LastEditTime: 2025-04-07 18:03:51
 * @LastEditors: ywj@originqc.com
 */
import React from 'react'
import { useNavigate } from 'react-router-dom';
import './index.scss'
interface ICrumb { 
  title: string,
  subTitle:any,
}

const Crumb: React.FC<ICrumb> = (props) => {
  const { title, subTitle } = props;
  const navigate = useNavigate();

  const handleHome = () => { 
    navigate('/');
  }
  
  return (
    <div className='crumb-box'>
      <span>
        <span
          className='first'
          onClick={handleHome}>
          {title}
        </span>&nbsp;&nbsp;&gt;&nbsp;&nbsp;
        <span className='second'
          // dangerouslySetInnerHTML={{ __html: subTitle }}
        >{ subTitle}</span>
      </span>
    </div>
  )
}

export default Crumb;